import { useMutation } from "@tanstack/react-query";

import { authApi } from "@/features/identity/services/auth.api";
import { queryClient } from "@/lib/query-client";
import { clearAccessToken } from "@/lib/token-storage";
import { useAppDispatch } from "@/store/hooks";
import { clearCredentials } from "@/store/auth/authSlice";

/**
 * Always calls the server (invalidates the refresh cookie) before clearing
 * local state — the reverse order would leave a still-valid refresh cookie
 * sitting in the browser after the UI already looks logged out. Clears
 * local state (token, Redux `auth`, query cache) even if the server call
 * fails, so a network blip can't leave the user stuck "logged in" with a
 * token the UI no longer has anywhere to read from.
 */
export function useLogout() {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: authApi.logout,
    onSettled: () => {
      clearAccessToken();
      dispatch(clearCredentials());
      queryClient.clear();
    },
  });
}
